<script setup lang="ts">
import PlusIcon from '@/assets/icons/PlusIcon.vue';
import CustomButton from '@/core/elements/CustomButton.vue';
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    theme?: 'primary' | 'secondary' | 'text' | 'link' | 'surface';
    label: string;
    disabled?: boolean;
    hideLabelOnMobile?: boolean;
    /** Icon only while the surrounding PageHeader is too narrow for the label. */
    hideLabelInNarrowHeader?: boolean;
  }>(),
  {
    theme: 'primary',
    hideLabelOnMobile: false,
    hideLabelInNarrowHeader: false,
  },
);

const labelClasses = computed<string[]>(() => [
  'text-body',
  props.hideLabelOnMobile ? 'hidden md:block' : 'block',
  props.hideLabelInNarrowHeader ? '[@container(max-width:560px)]:hidden' : '',
]);

const ariaLabel = computed<string | undefined>(() =>
  props.hideLabelOnMobile || props.hideLabelInNarrowHeader ? props.label : undefined,
);
</script>

<template>
  <CustomButton
    v-if="props.hideLabelOnMobile && props.theme !== 'link'"
    ref="buttonRef"
    :theme="props.theme"
    :disabled="props.disabled"
    :aria-label="ariaLabel"
    class="max-md:size-button max-md:min-size-button max-md:justify-center max-md:px-xs max-md:py-sm max-md:shrink-0"
  >
    <PlusIcon class="size-icon" />
    <div :class="labelClasses">{{ props.label }}</div>
  </CustomButton>
  <CustomButton
    v-else
    ref="buttonRef"
    :theme="props.theme"
    :disabled="props.disabled"
    :aria-label="ariaLabel"
    :class="
      props.hideLabelInNarrowHeader &&
      '[@container(max-width:560px)]:size-button [@container(max-width:560px)]:justify-center [@container(max-width:560px)]:px-xs'
    "
  >
    <PlusIcon v-if="props.theme !== 'link'" class="size-icon" />
    <div :class="labelClasses">{{ props.label }}</div>
  </CustomButton>
</template>
